import { render } from "./Telemetry.vue?vue&type=template&id=4aa06e4c&scoped=true"
import script from "./Telemetry.vue?vue&type=script&lang=js"
export * from "./Telemetry.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4aa06e4c"

export default script